export const PAGE_PATH = '/user';
